<script>
    /**
     * Single month view calendar for marketing pages
     * @requires ./BaseCalendar.vue
     * @displayName SingleMarketingCalendar
     */
    import BaseCalendar from './BaseCalendar.vue'

    export default {
        name: 'SingleMarketingCalendar',
        extends: BaseCalendar,
        computed: {
            monthsClass: () => () => ({})
        }
    }
</script>
